/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_common_requestCheckIbowIdExistence } from '../models/api_common_requestCheckIbowIdExistence';
import type { api_common_requestGetHoliday } from '../models/api_common_requestGetHoliday';
import type { api_common_requestGetIbowStaffInfo } from '../models/api_common_requestGetIbowStaffInfo';
import type { api_common_requestGetSessionInfo } from '../models/api_common_requestGetSessionInfo';
import type { api_common_requestGetShortUrl } from '../models/api_common_requestGetShortUrl';
import type { api_common_responseCheckIbowIdExistence } from '../models/api_common_responseCheckIbowIdExistence';
import type { api_common_responseCheckMaintenance } from '../models/api_common_responseCheckMaintenance';
import type { api_common_responseGetHoliday } from '../models/api_common_responseGetHoliday';
import type { api_common_responseGetIbowStaffInfo } from '../models/api_common_responseGetIbowStaffInfo';
import type { api_common_responseGetSessionInfo } from '../models/api_common_responseGetSessionInfo';
import type { api_common_responseGetShortUrl } from '../models/api_common_responseGetShortUrl';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CommonService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Holiday
     * 指定された期間内の祝日を取得する
     * @returns api_common_responseGetHoliday responseGetHoliday
     * @throws ApiError
     */
    public postHolidayGet({
        body,
    }: {
        /**
         * requestGetHoliday
         */
        body: api_common_requestGetHoliday,
    }): CancelablePromise<api_common_responseGetHoliday> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/holiday/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Check Ibow Id Existence
     * Check Ibow Id Existence
     * @returns api_common_responseCheckIbowIdExistence responseCheckIbowIdExistence
     * @throws ApiError
     */
    public postIbowIdCheckExistence({
        body,
    }: {
        /**
         * requestCheckIbowIdExistence
         */
        body: api_common_requestCheckIbowIdExistence,
    }): CancelablePromise<api_common_responseCheckIbowIdExistence> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/ibow_id/check_existence',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get IbowStaffInfo
     * iBowの職員情報を取得する
     * @returns api_common_responseGetIbowStaffInfo responseGetIbowStaffInfo
     * @throws ApiError
     */
    public postIbowStaffInfoGet({
        body,
    }: {
        /**
         * requestGetIbowStaffInfo
         */
        body: api_common_requestGetIbowStaffInfo,
    }): CancelablePromise<api_common_responseGetIbowStaffInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/ibow_staff_info/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Check Maintenance
     * 現在、メンテナンス中かどうかを確認する
     * @returns api_common_responseCheckMaintenance responseCheckMaintenance
     * @throws ApiError
     */
    public postMaintenanceCheck(): CancelablePromise<api_common_responseCheckMaintenance> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/maintenance/check',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Session info
     * Get EwellUser/RequestUser/PortalStaff
     * @returns api_common_responseGetSessionInfo responseGetSessionInfo
     * @throws ApiError
     */
    public postSessionInfoGet({
        body,
    }: {
        /**
         * requestGetSessionInfo
         */
        body: api_common_requestGetSessionInfo,
    }): CancelablePromise<api_common_responseGetSessionInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/session_info/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get ShortUrl
     * キーを元に、短縮URLの情報を取得する
     * @returns api_common_responseGetShortUrl responseGetShortUrl
     * @throws ApiError
     */
    public postShortUrlGet({
        body,
    }: {
        /**
         * requestGetShortUrl
         */
        body: api_common_requestGetShortUrl,
    }): CancelablePromise<api_common_responseGetShortUrl> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/short_url/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
